import axios from 'axios'
import { Interweave } from 'interweave'
import React, { useEffect, useState } from 'react'
import { Apiurl } from '../api_urls'
import { GToaster } from './g_toaster'
const toster = new GToaster()
const MarqueeView = ({ usertype }) => {

    const [getdata, setgetdata] = useState(null)
    const getalert = async () => {
        await axios.get(Apiurl.GET_MARQUEE_ALERT).then((response) => {
            if (response.status === 200) {
                if (response.data?.status === 200) {
                    setgetdata(response.data.data)
                } else {
                    toster.error({ title: "Server Error" });
                }
            } else {
                toster.error({ title: "Server Error" });
            }
        })
    }

    useEffect(() => {
        getalert()
    }, [])

    return (
        <div class="marquee-container">
            <div class="marquee-text">
                <Interweave content={usertype === "passenger" ? getdata?.passenger_message : getdata?.driver_message} />
            </div>
        </div>
    )
}

export default MarqueeView